import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.less']
})
export class LegalComponent extends AppComponentBase {

    constructor(
        injector: Injector) {
        super(injector);
    }

}
